module.exports = __webpack_public_path__ + "media/logos/bloomberg-logo-white-small-23958377.png";